import * as React from "react";
import { makeStyles } from "@fluentui/react-components";
import ContentReady from "./ContentReady";
import SlidesContentReady from "./SlidesContentReady";
import { getContentReadyMode } from "@/utils/slides/slidesJobs";
import { LS_KEY_CONTENT_READY_MODE } from "@/utils/slides/slidesTaskpaneContract";
import "../../styles/globals.css";

const useStyles = makeStyles({
  root: {
    minHeight: "100vh",
  },
});

const App: React.FC = () => {
  const styles = useStyles();
  const [mode, setMode] = React.useState(() => getContentReadyMode());

  React.useEffect(() => {
    const onStorage = (event: StorageEvent) => {
      if (event.key === LS_KEY_CONTENT_READY_MODE || event.key === null) {
        setMode(getContentReadyMode());
      }
    };
    const onMessage = (event: MessageEvent) => {
      const t = event?.data?.type;
      if (t === "SLIDES_CONTENT_READY" || t === "SLIDES_JOBS_CHANGED") {
        setMode(getContentReadyMode());
      }
    };
    window.addEventListener("storage", onStorage);
    window.addEventListener("message", onMessage);
    return () => {
      window.removeEventListener("storage", onStorage);
      window.removeEventListener("message", onMessage);
    };
  }, []);

  return (
    <div className={styles.root}>
      {mode === "slides" ? <SlidesContentReady /> : <ContentReady />}
    </div>
  );
};

export default App;
